import type { RouteLocationNormalizedGeneric } from 'vue-router';
import { getSelfServiceUrl } from '~/composables/useSelfServiceUrl';

/**
 * The Keycloak Self Service URL for giving the Academy consent.
 *
 * Cannot be authored in Storyblok, which is why the fallback story's call to action is a blok rather
 * than a plain link: the `postsave-callback` is built at runtime from the environment's base URL and
 * the locale-resolved Academy path. It points at the waiting page rather than the originating page,
 * because the consent is processed asynchronously and the account is still inactive on return.
 */
export const useConsentSelfServiceUrl = (route?: RouteLocationNormalizedGeneric) => {
    const runtimeConfig = useRuntimeConfig();
    const currentRoute = route ?? useRoute();
    const consentPendingUrl = useAcademyConsentPendingUrl(route);

    return computed(() =>
        getSelfServiceUrl(
            runtimeConfig.public.baseUrl,
            currentRoute.fullPath,
            runtimeConfig.public.keycloakUrl,
            'consents',
            [],
            { postsaveRedirectTo: consentPendingUrl.value }
        )
    );
};
